import { useTranslation } from "react-i18next";
import { cssbuySpreadsheetContent } from "@/mocks/cssbuy-spreadsheet-content";
import ArticlePage from "@/components/feature/ArticlePage";

export default function CSSBuyWarehousePage() {
  const { i18n } = useTranslation();
  const lang = i18n.language as "en" | "pt-BR" | "de";
  const content = cssbuySpreadsheetContent[lang] || cssbuySpreadsheetContent.en;

  return <ArticlePage content={content} />;
}